export const types = {
    FETCH_REQUEST: 'OFFER_VEHICLES_FETCH_REQUEST',
    FETCH_SUCCESS: 'OFFER_VEHICLES_FETCH_SUCCESS',
    FETCH_FAILURE: 'OFFER_VEHICLES_FETCH_FAILURE',

    VEHICLE_SELECT: 'OFFER_VEHICLES_VEHICLE_SELECT',
    TOGGLE_STATE: 'OFFER_VEHICLES_TOGGLE_STATE',
    CLEANUP: 'OFFER_VEHICLES_CLEANUP',
}